import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../CSS/Header.css";
import firebase from 'firebase/compat/app';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChevronDown, faBars} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const Header=()=>{
    const location = useLocation();
    const navigate = useNavigate();

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [menuVisible, setMenuVisible] = useState(false);

    useEffect(() => {
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      });
      return unsubscribe;
    }, []);

const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getServicesTitle");
        setServices(response.data);
        console.log("Fetched Services:", response.data); 
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  const handleLogout = () => {
    firebase.auth().signOut().then(() => {
      setIsLoggedIn(false);
      navigate("/");
    });
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible); // Toggle the mobile menu visibility
  };


  const [isAdmin, setIsAdmin] = useState(false);

  
useEffect(()=>{
  const checkAdminStatus=()=>{
  firebase.auth().onAuthStateChanged((user)=>{
    if(user){
      const userEmail=user.email;
      firebase.database().ref('Admin').orderByValue().equalTo(userEmail).once('value')
        .then((snapshot)=>{
          if (snapshot.exists()) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        }).catch((error)=>{
          console.error("Error checking admin status:",error);
        })
    }else{
      setIsAdmin(false);
    }

  })
  }
  checkAdminStatus();
},[]);

    return(
        <nav className="navbar navbar-expand-lg ftco_navbar ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand" href="/" style={{ color: "white" }}>
            <div className="NavbarTitle"></div>
           
          </a>
          <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu} // Toggle the menu when clicked
          aria-controls="ftco-nav"
          aria-expanded={menuVisible ? 'true' : 'false'}
          aria-label="Toggle navigation"
          style={{backgroundColor: "black"}}
        >
          <FontAwesomeIcon icon={faBars} className="fabarsicon"/> {/* Hamburger icon */}
        </button>
        <div className={`collapse navbar-collapse ${menuVisible ? 'show' : ''}`} id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>
              <li className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}>
                <Link to="/about" className="nav-link">
                  About
                </Link>
              </li>
              {/* <li className={`nav-item ${location.pathname === '/service' ? 'active' : ''}`}>
                <Link to="/service" className="nav-link">
                  Services
                </Link>
              </li> */}
              <li className="nav-item dropdown1 position-relative">
                <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  Services
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/service/KidsCoaching" className="dropdown-item">Kids Coaching</Link>
                  </li>
                  <li>
                    <Link to="/service/AdultCoaching" className="dropdown-item">Adults Coaching</Link>
                  </li>
                  <li>
                    <Link to="/service/Membership" className="dropdown-item">Membership</Link>
                  </li>
                  <li>
                    <Link to="/service/Booking" className="dropdown-item">Booking</Link>
                  </li>
                </ul>
              </li>
              <li className={`nav-item ${location.pathname === '/gallery' ? 'active' : ''}`}>
                <Link to="/gallery" className="nav-link">
                  Gallery
                </Link>
              </li>
              {/* <li className="nav-item dropdown1 position-relative">
                <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  Sports Training
                </a>
                <ul className="dropdown-menu">
                  {services.map((service) => (
                    <li key={service.service_id}>
                      <Link to={`/services${service.route}`} className="dropdown-item">
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li> */}
              {/* <li className="nav-item dropdown1 position-relative">
                <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  Sports Training
                </a>
                <ul className="dropdown-menu">
                  <li className="dropdown-submenu position-relative">
                    <Link to="#" className="dropdown-item">Badminton</Link>
                    <ul className="dropdown-menu1">
                      <li><Link to="/services/Badminton" className="dropdown-item">Adult</Link></li>
                    </ul>
                  </li>
                  <li><Link to="/services/Yoga" className="dropdown-item">Yoga</Link></li>
                </ul>
              </li> */}

              <li className={`nav-item ${location.pathname === '/contact' ? 'active' : ''}`}>
                <Link to="/contact" className="nav-link">
                  Contact
                </Link>
              </li>
            </ul>
            {/* <div className="user-menu">
              <div className="dropdown">
                <FontAwesomeIcon icon={faUser} className="user-icon" />
                <div className="dropdown-content">
                  {isLoggedIn ? (
                    <a href="#" onClick={handleLogout}>Logout</a>
                  ) : (
                    <Link to="/auth" className="nav-link">Login</Link>
                  )}
                </div>
              </div>
            </div> */}
            <div className="user-menu">
            <div className="dropdown">
              <FontAwesomeIcon icon={faUser} className="user-icon" />
              <div className="dropdown-content">
               {isLoggedIn ? (
                <>
                {/* {isAdmin && <a href="/workedit">Work</a>} */}
                {isAdmin && <a href="/galleryedit">Gallery</a>}
                {/* {isAdmin && <a href="/offeredit">Offer</a>} */}
                {isAdmin && <a href="/serviceedit">Service</a>}
                {isAdmin && <a href="/sociallinks">Social Links</a>}
                <a href="/profile">Profile</a>
                {isAdmin && <a href="/seo">SEO</a>}
                {isAdmin && <a href="/newperson">Form</a>}
                {isAdmin && <a href="/attendanceform">Attendace</a>}
                {isAdmin && <a href="/paymentform">Payment</a>}
                {isAdmin && <a href="/Attendancedashboard">Attendace Dashboard</a>}
                {isAdmin && <a href="/Paymentdashboard">Payment Dashboard</a>}
                {isAdmin && <a href="/testimonialfilter">Admin Page</a>}
                <a href="/" onClick={handleLogout}>Logout</a>
                  </>
               ):(
                  <a href="/auth">Login</a>
               )}
            
              </div>
            </div>
          </div>
          </div>
        </div>
      </nav>
    );
}

export default Header;